module.exports = __webpack_public_path__ + "static/img/icon3.42f686e1.png";